import { useQuery } from '@tanstack/react-query';
import ApiRoutes from 'src/constants/ApiRoutes';
import { getHeaders } from 'src/services/api';
import { ApiError } from 'src/types/Api';

type PostcodeSearchRequest = {
    query: string;
};

export type PostcodeSearchResponse = {
    suburb: string;
    postcode: string;
    state: string;
}[];

async function getPostcodeSearch(
    params: PostcodeSearchRequest,
): Promise<PostcodeSearchResponse> {
    const res = await fetch(ApiRoutes.POSTCODE_SEARCH(params.query), {
        method: 'GET',
        headers: getHeaders(),
    });
    const data = await res.json();
    if (!res.ok) {
        throw data as ApiError;
    }

    return data as PostcodeSearchResponse;
}

export const usePostcodeSearch = (params: PostcodeSearchRequest) => {
    return useQuery<PostcodeSearchResponse>({
        queryKey: ['PostcodeSearch', params.query],
        queryFn: () => getPostcodeSearch(params),
        enabled: params.query.length > 2,
    });
};
